export default "__VITE_ASSET__Dyu6kVKj__"